// Cart drawer upsell — carousel + add to cart + restore on delete
(function() {
  if (window.__cartDrawerUpsellInit) return;
  window.__cartDrawerUpsellInit = true;

  var carouselState = {};
  // var BTN_LABEL = 'Quick Add';
  // var ARROW_PREV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  // var ARROW_NEXT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';

  function getCartAddUrl() {
    if (window.theme && window.theme.routes && window.theme.routes.cartAdd) {
      return window.theme.routes.cartAdd;
    }
    return '/cart/add.js';
  }

  function getRoot(el) {
    return el ? el.closest('[data-cart-drawer-upsell]') : null;
  }

  function getCatalog() {
    var el = document.querySelector('[data-upsell-catalog]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function getState(root) {
    var id = root.getAttribute('data-cdu-instance');
    if (!id) {
      id = 'cdu-' + Date.now();
      root.setAttribute('data-cdu-instance', id);
    }
    if (!carouselState[id]) {
      carouselState[id] = { index: 0 };
    }
    return carouselState[id];
  }

  function buildSlideHTML(item) {
    var imageHtml = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="64" height="64" loading="lazy">'
      : '<div class="cdu-card__image-placeholder"></div>';

    return (
      '<div class="cdu-slide" data-upsell-slide data-product-id="' + item.productId + '">' +
        '<div class="cdu-card">' +
          '<a href="' + item.url + '" class="cdu-card__image" tabindex="-1" aria-hidden="true">' + imageHtml + '</a>' +
          '<div class="cdu-card__info">' +
            '<a href="' + item.url + '" class="cdu-card__title">' + escapeHtml(item.title) + '</a>' +
            '<p class="cdu-card__price">' + escapeHtml(item.priceFormatted) + '</p>' +
          '</div>' +
          '<button type="button" class="cdu-card__btn" data-upsell-add data-variant-id="' + item.variantId + '" data-product-id="' + item.productId + '" data-btn-label="' + BTN_LABEL + '"><span class="cdu-card__btn-icon" aria-hidden="true">+</span> ' + BTN_LABEL + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function rebuildNav(root, count) {
    var nav = root.querySelector('[data-upsell-nav]');
    if (!nav) return;

    if (count <= 1) {
      nav.innerHTML = '';
      nav.style.display = 'none';
      return;
    }

    nav.style.display = '';
    var dotsHtml = '';
    for (var i = 0; i < count; i++) {
      dotsHtml +=
        '<button type="button" class="cdu__dot' + (i === 0 ? ' cdu__dot--active' : '') + '" data-upsell-dot="' + i + '" aria-label="Show product ' + (i + 1) + '"' + (i === 0 ? ' aria-selected="true"' : '') + '></button>';
    }

    nav.innerHTML =
      '<div class="cdu__dots" data-upsell-dots role="tablist" aria-label="Upsell products">' + dotsHtml + '</div>' +
      '<div class="cdu__arrows">' +
        '<button type="button" class="cdu__arrow cdu__arrow--prev" data-upsell-prev aria-label="Previous product" disabled>' + ARROW_PREV + '</button>' +
        '<button type="button" class="cdu__arrow cdu__arrow--next" data-upsell-next aria-label="Next product">' + ARROW_NEXT + '</button>' +
      '</div>';
  }

  function updateCarousel(root) {
    if (!root) return;

    var viewport = root.querySelector('[data-upsell-viewport]');
    var track = root.querySelector('[data-upsell-track]');
    var slides = root.querySelectorAll('[data-upsell-slide]');
    var prevBtn = root.querySelector('[data-upsell-prev]');
    var nextBtn = root.querySelector('[data-upsell-next]');
    var dots = root.querySelectorAll('[data-upsell-dot]');
    var state = getState(root);

    if (!track || !viewport || !slides.length) {
      root.classList.add('is-hidden');
      return;
    }

    root.classList.remove('is-hidden');

    if (state.index >= slides.length) {
      state.index = slides.length - 1;
    }
    if (state.index < 0) {
      state.index = 0;
    }

    var slideWidth = viewport.offsetWidth;
    track.style.transform = 'translate3d(-' + (state.index * slideWidth) + 'px, 0, 0)';

    dots.forEach(function(dot, i) {
      var active = i === state.index;
      dot.classList.toggle('cdu__dot--active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (prevBtn) prevBtn.disabled = state.index === 0;
    if (nextBtn) nextBtn.disabled = state.index >= slides.length - 1;
  }

  function setupSwipe(root) {
    if (root.dataset.swipeBound) return;
    root.dataset.swipeBound = 'true';

    var viewport = root.querySelector('[data-upsell-viewport]');
    var track = root.querySelector('[data-upsell-track]');
    if (!viewport || !track) return;

    var startX = 0;
    var startY = 0;
    var currentX = 0;
    var isDragging = false;
    var threshold = 45;

    function getTranslate(index, extra) {
      var w = viewport.offsetWidth;
      return -(index * w) + (extra || 0);
    }

    viewport.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1) return;
      if (e.target.closest('[data-upsell-add]')) return;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      currentX = 0;
      isDragging = true;
      viewport.classList.add('is-dragging');
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      if (!isDragging) return;

      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (Math.abs(dx) < Math.abs(dy) && Math.abs(currentX) < 8) return;

      if (Math.abs(dx) > 8) {
        e.preventDefault();
        currentX = dx;
        var state = getState(root);
        track.style.transform = 'translate3d(' + getTranslate(state.index, dx) + 'px, 0, 0)';
      }
    }, { passive: false });

    function endSwipe() {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');

      var state = getState(root);
      var slides = root.querySelectorAll('[data-upsell-slide]');

      if (currentX < -threshold && state.index < slides.length - 1) {
        state.index += 1;
      } else if (currentX > threshold && state.index > 0) {
        state.index -= 1;
      }

      currentX = 0;
      updateCarousel(root);
    }

    viewport.addEventListener('touchend', endSwipe, { passive: true });
    viewport.addEventListener('touchcancel', endSwipe, { passive: true });
  }

  function initSwipeAll() {
    document.querySelectorAll('[data-cart-drawer-upsell]').forEach(setupSwipe);
  }

  function rebuildUpsell(cart) {
    var root = document.querySelector('[data-cart-drawer-upsell]');
    var catalog = getCatalog();
    if (!root || !catalog.length) return;

    if (!cart || !cart.item_count) {
      root.classList.add('is-hidden');
      return;
    }

    var cartProductIds = cart.items.map(function(item) {
      return item.product_id;
    });

    var visible = catalog.filter(function(item) {
      return item.available && cartProductIds.indexOf(item.productId) === -1;
    });

    var track = root.querySelector('[data-upsell-track]');
    if (!track) return;

    if (!visible.length) {
      track.innerHTML = '';
      rebuildNav(root, 0);
      root.classList.add('is-hidden');
      return;
    }

    var state = getState(root);
    var prevCount = root.querySelectorAll('[data-upsell-slide]').length;
    if (visible.length !== prevCount) {
      state.index = 0;
    }

    track.innerHTML = visible.map(buildSlideHTML).join('');
    rebuildNav(root, visible.length);
    root.setAttribute('data-slide-count', visible.length);
    updateCarousel(root);
    setupSwipe(root);
  }

  function resolveCart(source) {
    if (source && source.detail && source.detail.cart) {
      return Promise.resolve(source.detail.cart);
    }
    if (source && source.items) {
      return Promise.resolve(source);
    }
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function refreshUpsell(source) {
    resolveCart(source).then(function(cart) {
      rebuildUpsell(cart);
    });
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    var originalLabel = btn.getAttribute('data-btn-label') || BTN_LABEL;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok || data.status === 422) {
            throw new Error(data.description || data.message || 'Could not add item');
          }
          return data;
        });
      })
      .then(function(data) {
        btn.textContent = 'Added!';
        btn.classList.add('cdu-card__btn--added');

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));

        return fetch('/cart.js').then(function(r) { return r.json(); });
      })
      .then(function(cart) {
        rebuildUpsell(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      })
      .catch(function(err) {
        console.error('Upsell add error:', err);
        btn.disabled = false;
        btn.innerHTML = '<span class="cdu-card__btn-icon" aria-hidden="true">+</span> ' + originalLabel;
        alert(err.message || 'Try again');
      });
  }

  document.addEventListener('click', function(e) {
    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(addBtn);
      return;
    }

    var prevBtn = e.target.closest('[data-upsell-prev]');
    if (prevBtn) {
      e.preventDefault();
      e.stopPropagation();
      var rootPrev = getRoot(prevBtn);
      if (!rootPrev || prevBtn.disabled) return;
      getState(rootPrev).index -= 1;
      updateCarousel(rootPrev);
      return;
    }

    var nextBtn = e.target.closest('[data-upsell-next]');
    if (nextBtn) {
      e.preventDefault();
      e.stopPropagation();
      var rootNext = getRoot(nextBtn);
      if (!rootNext || nextBtn.disabled) return;
      getState(rootNext).index += 1;
      updateCarousel(rootNext);
      return;
    }

    var dot = e.target.closest('[data-upsell-dot]');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      var rootDot = getRoot(dot);
      if (!rootDot) return;
      getState(rootDot).index = parseInt(dot.getAttribute('data-upsell-dot'), 10) || 0;
      updateCarousel(rootDot);
    }
  });

  document.addEventListener('cart:updated', refreshUpsell);
  document.addEventListener('cart:refresh', refreshUpsell);

  document.addEventListener('drawerOpen.CartDrawer', function() {
    refreshUpsell();
    setTimeout(function() {
      document.querySelectorAll('[data-cart-drawer-upsell]').forEach(updateCarousel);
    }, 100);
  });

  window.addEventListener('resize', function() {
    document.querySelectorAll('[data-cart-drawer-upsell]').forEach(updateCarousel);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      refreshUpsell();
      initSwipeAll();
    });
  } else {
    refreshUpsell();
    initSwipeAll();
  }

  document.addEventListener('page:loaded', function() {
    refreshUpsell();
    initSwipeAll();
  });
})();
